import { VueQueryPlugin, QueryClient } from "@tanstack/vue-query";

import { registerSessionCleanup } from "~/core/services/authentication.service";
import { useUserStore } from "~/composables/user-store";

import { ApiError, isUnauthorizedError } from "~/core/utils/api";

export default defineNuxtPlugin((nuxtApp) => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        throwOnError: (error) => !isUnauthorizedError(error),
        retry: (failureCount, error) => {
          // Inutile de retenter une erreur client (4xx) : un 403/404/422 ne
          // se résout pas en réessayant — on évite la rafale de requêtes
          // (cf. la 403 sur /activity-categories/ rejouée 4× dans Sentry).
          if (
            error instanceof ApiError &&
            error.status !== undefined &&
            error.status >= 400 &&
            error.status < 500
          ) {
            return false;
          }
          return failureCount < 3;
        },
      },
      mutations: {
        throwOnError: (error) => !isUnauthorizedError(error),
      },
    },
  });
  const userStore = useUserStore();
  registerSessionCleanup(() => {
    userStore.$reset();
    queryClient.clear();
  });
  nuxtApp.vueApp.use(VueQueryPlugin, { queryClient });
});
